import { Button } from '@heroui/react';
import { memo } from 'react';
import isEqual from 'react-fast-compare';

const AddFormHeader = memo(
  ({ onClose, loading }: { onClose: () => void; loading: boolean }) => {
    return (
      <>
        <header className='  fixed top-0 w-full left-0 px-6 bg-white z-50 pt-safe '>
          <div className='flex items-center justify-between py-4'>
            <span
              className='text-gray-800 w-6 h-6 -ml-1 flex items-center justify-center '
              onClick={onClose}
            >
              <i className='ic-round md-close text-2xl' />
            </span>
            <Button
              color='primary'
              radius='full'
              className='font-bold text-sm'
              isLoading={loading}
              size='sm'
              type='submit'
              // onClick={(e) => {
              //   e.stopPropagation();
              // }}
            >
              保存
            </Button>
          </div>
        </header>
        <div className='h-[64px] mb-4' />
      </>
    );
  },
  isEqual
);

export default AddFormHeader;
